import React from 'react'
import PropTypes from 'prop-types'
import { Container, Box, Text } from '@chakra-ui/react'
import Navbar from '../NewNavBar/Navbar'
import { Row, Col } from 'react-flexbox-grid'
import CommonButton from '../../components/NewButton/index'
import {
  Banner,
  BannerBg,
  BannerTextWrapper,
  BannerCenterTextWrapper,
  Heading,
  RowWrapper,
  FullWidthGrid,
  Headings,
  Inner,
  BannerTitle,
  SubBannerTitle,
} from './styles'
import { Link } from 'gatsby'

const PageBanner = ({ title, subtitle, bgImage, actions, isCenter }) => {
  return (
    <>
      <Banner image={bgImage?.file?.url} data-key="page-banner">
        <BannerBg>
          <Container
            maxW={[
              'container.sm',
              'container.md',
              'container.lg',
              'container.xl',
            ]}
            paddingTop="50px"
          >
            <Navbar />

            {isCenter ? (
              <RowWrapper>
                <Box as={BannerCenterTextWrapper}>
                  <Text
                    as={'h1'}
                    fontSize={['42px', '60px', '66px', '48px']}
                    lineHeight={['42px', '60px', '66px', '1']}
                    fontWeight="bold"
                    letterSpacing="-2.01026px"
                    textAlign="center"
                    color="#FFFFFF"
                  >
                    {title}
                  </Text>

                  <Text
                    fontSize={['32px', '', '32px', '36px']}
                    textAlign="center"
                    color="#FFFFFF"
                  >
                    {subtitle}
                  </Text>
                </Box>
              </RowWrapper>
            ) : (
              <Row>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Box as={BannerTextWrapper}>
                    <Text
                      as={Heading}
                      dangerouslySetInnerHTML={{ __html: title || '' }}
                      fontSize={['42px', '60px', '66px', '60px']}
                      lineHeight={['42px', '60px', '66px', '1']}
                      textAlign={['center', 'center', 'center', 'left']}
                    />
                  </Box>
                </Col>
                <Col xs={0} sm={0} md={0} lg={6}></Col>
                {(actions || []).map((item) => (
                  <Box margin={['0 auto', '0 auto', '0 auto', '0']}>
                    <CommonButton as={Link} to="/properties">
                      {item.text}
                    </CommonButton>
                  </Box>
                ))}
              </Row>
            )}
          </Container>
        </BannerBg>
      </Banner>
    </>
  )
}

PageBanner.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  subtitle: PropTypes.string,
  title: PropTypes.string,
  customTitle: PropTypes.string,
}

export default PageBanner
